import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (ok) navigate("/sports/mlb");
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center"
        style={{ backgroundImage: "url(https://images.unsplash.com/photo-1778050203444-90920c7a5652?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920)" }}
      />
      <div className="absolute inset-0 -z-10 bg-black/85" />

      <div className="w-full max-w-md bg-[#121212] border border-white/10 p-8 rounded-sm" data-testid="login-card">
        <div className="mb-6">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#007AFF] mb-2">Authentication</div>
          <h1 className="font-display text-5xl leading-none">SIGN IN</h1>
          <p className="text-sm text-zinc-400 mt-3">Track streaks. Hunt patterns. Own the season.</p>
        </div>
        <form onSubmit={handle} className="space-y-4">
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-zinc-400">Email</label>
            <input
              data-testid="login-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-[#0A0A0A] border border-white/10 focus:border-[#007AFF] focus:outline-none rounded-sm px-3 py-2.5 font-mono-d text-sm"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-zinc-400">Password</label>
            <input
              data-testid="login-password-input"
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full bg-[#0A0A0A] border border-white/10 focus:border-[#007AFF] focus:outline-none rounded-sm px-3 py-2.5 font-mono-d text-sm"
              placeholder="••••••••"
            />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-[#FF3B30] border border-[#FF3B30]/30 px-3 py-2 rounded-sm">{error}</div>}
          <button
            data-testid="login-submit-button"
            disabled={submitting}
            className="w-full bg-[#007AFF] hover:bg-[#0064D6] text-white font-bold uppercase tracking-wider py-3 rounded-sm transition-all disabled:opacity-50 hover:-translate-y-0.5"
          >
            {submitting ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="mt-6 text-center text-sm text-zinc-400">
          New here? <Link to="/register" className="text-[#007AFF] hover:underline" data-testid="login-to-register">Create an account</Link>
        </div>
      </div>
    </div>
  );
}
